import { GetPreviousCorrectiveImagesType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getPreviousCorrectiveImages/getPreviousCorrectiveImages.type';
import { getPreviousCorrectiveImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getPreviousCorrectiveImages/getPreviousCorrectiveImagesFunction';
import { queryOptions } from '@tanstack/react-query';

export const getPreviousCorrectiveImagesOptions = (
  params: GetPreviousCorrectiveImagesType,
) => {
  return queryOptions({
    queryKey: ['getPreviousCorrectiveImagesOptions', params],
    queryFn: () => getPreviousCorrectiveImagesFunction(params),
  });
};
